<header class="takeoff-header-container">
    @let plan = selectedPlan();
    @let storedPlan = storeSelectedPlan | async;

    <div class="takeoff-file-name">
        <input
            type="text"
            class="text-input takeoff-file-name"
            #planNameInput="ngModel"
            [ngModel]="planName()"
            (blur)="onPlanNameChange(planNameInput)"
            [tooltip]="planName()" />
    </div>
    <div id="actions">
        <div class="take-off-actions-container">
            <div class="take-off-actions">
                @let config = takeOffConfig();
                @let isPlanScaled = !!plan?.Scale && !!plan?.VScale;
                @if (config) {
                    <app-take-off-drawing-actions
                        [isDisabled]="takeOffInprogress() || !isPlanScaled"
                        [config]="config"
                        [takeoffMeasurement]="selectedMeasurement()"
                        (shapeChanges)="onShapeChanged($event)"
                        (colorChanges)="onColorChanged($event)"
                        (pitchChanges)="onPitchChanged($event)"
                        (deductionChanges)="onDeduct()"
                        (depthChanges)="onDepthChanged($event)"
                        (depthUnitChanges)="onDepthUnitChanged($event)"
                        (pointEditChanges)="onPointEditModeChanged()">
                    </app-take-off-drawing-actions>
                }
            </div>

            @if (showAutoMeasure()) {
                <app-take-off-additional-actions
                    [isPlanScaled]="isPlanScaled || storedPlan?.Scale"
                    (autoMeasureFloor)="onAutoMeasureFloor($event)"
                    (requestAddOn)="onRequestAddOn()">
                </app-take-off-additional-actions>
            }
        </div>
    </div>

    <div class="take-off-user-action" id="user-action">
        <button
            id="undo-last-drawing"
            type="button"
            class="btn-bx-secondary-stroked btn-large mr-2"
            tooltip="Undo the last drawing"
            placement="bottom"
            [disabled]="!hasDrawings() || takeOffInprogress() || !selectedMeasurement() || !isPlanScaled"
            (click)="onUndoLastDrawing()">
            <i class="fa-light fa-arrow-turn-left undo"></i>
        </button>

        <button
            type="button"
            class="btn-bx-secondary-stroked btn-large"
            tooltip="Remove all drawings for the selected measurement"
            tooltip-append-to-body="true"
            [disabled]="!hasDrawings() || !isPlanScaled"
            (click)="onRemoveAll()">
            <i class="fa-light fa-trash-can"></i>
        </button>

        <div class="divider"></div>

        @if (isApplySelected()) {
            <button
                id="apply-selected"
                class="btn-bx-primary btn-large mr-2"
                (click)="saveChanges.emit()"
                [tooltip]="!selectedMeasurement() ? 'No measurement selected' : ''"
                [disabled]="!selectedMeasurement()">
                <i class="fa-light fa-floppy-disk mr-2"></i>Apply Selected
            </button>
            <button id="cancel-measurements" class="btn-bx-secondary-stroked btn-large" (click)="close()">
                <i class="fa-light fa-xmark"></i>
            </button>
        } @else if (isAutoSave()) {
            <button id="auto-save-close" class="btn-bx-secondary-stroked btn-large" (click)="close()">
                <i class="fa-light fa-floppy-disk mr-2"></i>Save and close
            </button>
        } @else {
            <button id="save-measurements" class="btn-bx-secondary-stroked btn-large mr-2" (click)="saveChanges.emit()">
                <i class="fa-light fa-floppy-disk mr-2"></i>Accept & Save
            </button>
            <button id="cancel-measurements" class="btn-bx-secondary-stroked btn-large" (click)="close()">
                <i class="fa-light fa-xmark"></i>
            </button>
        }
    </div>
</header>
